import Row from '@mv-submodules/inplant-components-fe/ui/components/Grid/Row'
import { Loader } from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/shared';
import { Workshift } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/workshift';
import React from 'react';

/**
 * Component: NeededChartDataAvailabilityGuard
 *
 * Guards chart rendering based on availability of required plant and workShift data.
 * 
 * - If either `plant` or `workShift` is null, renders a loading indicator row.
 * - Otherwise, renders children with assured, non-null plant and workShift values.
 *
 * Props:
 *   - plant: string | null
 *   - workShift: Workshift | null
 *   - children: function that receives guaranteed { plant, workShift }
 */
function NeededChartDataAvailabilityGuard(props: {
  plant: string | null
  workShift: Workshift | null
  children: ({ plant, workShift }: { plant: string; workShift: Workshift }) => JSX.Element
}) {
  const { plant, workShift } = props

  // Show loader until both plant and workShift are available
  if (plant == null || workShift == null) {
    return (
      <Row>
        <Loader />
      </Row>
    )
  }

  // Render children with guaranteed available data
  return props.children({ plant, workShift })
}

export default NeededChartDataAvailabilityGuard
